import BlockService from '@/services/BlockService'

const createContentModule = () => ({
  namespaced: true,
  state: {
    blocks: []
  },
  actions: {
    getBlock: async ({ commit, getters }, { name }) => {
      try {
        if (getters.blockByName(name)) {
          return
        }
        const { block } = await BlockService.getBlockByName(name)
        commit('SET_BLOCK', { block })
      } catch (ex) {
        console.error('content:getBlock: ', ex.message || ex)
      }
    }
  },
  mutations: {
    SET_BLOCK: ({ blocks }, { block }) => {
      if (block) {
        blocks.push(block)
      }
    }
  },
  getters: {
    blockByName:
      ({ blocks }) =>
      (name) =>
        blocks?.find((b) => b.name === name)
  }
})

export default createContentModule
